/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLegRequest
 */
export interface UpdateLegRequest {
    /**
     * Travel mode for this leg
     * @type {string}
     * @memberof UpdateLegRequest
     */
    travelMode?: UpdateLegRequestTravelModeEnum;
    /**
     * Manual override for travel time in minutes
     * @type {number}
     * @memberof UpdateLegRequest
     */
    travelTimeMinutes?: number;
    /**
     * Manual override for distance in meters
     * @type {number}
     * @memberof UpdateLegRequest
     */
    distanceMeters?: number;
    /**
     * Additional notes for this leg
     * @type {string}
     * @memberof UpdateLegRequest
     */
    notes?: string;
    /**
     * Whether to recalculate route and travel time using Mapbox (default: true if travel mode changed)
     * @type {boolean}
     * @memberof UpdateLegRequest
     */
    calculateRoute?: boolean;
}


/**
 * @export
 */
export const UpdateLegRequestTravelModeEnum = {
    Walking: 'WALKING',
    Driving: 'DRIVING',
    Cycling: 'CYCLING'
} as const;
export type UpdateLegRequestTravelModeEnum = typeof UpdateLegRequestTravelModeEnum[keyof typeof UpdateLegRequestTravelModeEnum];


/**
 * Check if a given object implements the UpdateLegRequest interface.
 */
export function instanceOfUpdateLegRequest(value: object): value is UpdateLegRequest {
    return true;
}

export function UpdateLegRequestFromJSON(json: any): UpdateLegRequest {
    return UpdateLegRequestFromJSONTyped(json, false);
}

export function UpdateLegRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLegRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'travelMode': json['travelMode'] == null ? undefined : json['travelMode'],
        'travelTimeMinutes': json['travelTimeMinutes'] == null ? undefined : json['travelTimeMinutes'],
        'distanceMeters': json['distanceMeters'] == null ? undefined : json['distanceMeters'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'calculateRoute': json['calculateRoute'] == null ? undefined : json['calculateRoute'],
    };
}

  export function UpdateLegRequestToJSON(json: any): UpdateLegRequest {
      return UpdateLegRequestToJSONTyped(json, false);
  }

  export function UpdateLegRequestToJSONTyped(value?: UpdateLegRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'travelMode': value['travelMode'],
        'travelTimeMinutes': value['travelTimeMinutes'],
        'distanceMeters': value['distanceMeters'],
        'notes': value['notes'],
        'calculateRoute': value['calculateRoute'],
    };
}

